import { Study } from '../StudyList';
import { getReviewId } from 'query/review';

export const removeTag = (tag: string, studyId: Study['id']) => {
  return fetch(`/api/reviews/v1/reviews/${getReviewId()}/studies/tags`, {
    method: 'DELETE',
    body: JSON.stringify({ study_ids: [studyId], tags: [tag] }),
    headers: { 'Content-Type': 'application/json' },
  });
};
